export const slugify = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/ç/g, "c")
    .replace(/[^a-z0-9\s-']/g, "")
    .trim()
    .replace(/\s|'/g, "-");

export const getClubLogoUrl = (settings = {}) => {
  return settings.logo_club || "/img/logo_club.png";
};

export const getUserAvatarUrl = (user = {}) => {
  return user?.photoURL || "/img/user_avatar.jpg";
};

export const getDisplayClubName = (settings = {}) => {
  return (
    settings.shortname_club ||
    settings.nom_club ||
    settings.nom_association ||
    "MonAppliTournoi"
  );
};

export const getFullClubName = (settings = {}) => {
  return (
    settings.nom_club ||
    settings.shortname_club ||
    settings.nom_association ||
    "MonAppliTournoi"
  );
};

export const isExternalUrl = (url = "") => {
  return /^https?:\/\//i.test(url);
};

export const safeOpenExternal = (url) => {
  if (!url) return;

  const target = isExternalUrl(url) ? url : `https://${url}`;
  window.open(target, "_blank", "noopener,noreferrer");
};

export const scrollToHomeSection = ({ sectionId, navigate, location }) => {
  const yOffset = -130;

  const scrollNow = () => {
    const element = document.getElementById(sectionId);

    if (!element) return false;

    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });

    return true;
  };

  if (location.pathname === "/") {
    const done = scrollNow();
    if (done) return;
  }

  navigate("/", {
    state: {
      scrollTo: sectionId,
    },
  });
};